import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import { useCallback, useEffect } from "react";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import FormContainer from "../../../../../../common/components/form_container";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { BancoPagamentoForm } from "../../../schemas/BancoPagamento_lista/BancoPagamento_form";
import { FormSwitchInput } from "../../../../../../common/components/masked_inputs/react_forms/form_switch_input";
import { BancoPagamento } from "../../../../domain/models/banco_pagamento";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";

/**
 * CadastroRecebimentoModal
 */

type Props = {
    open: boolean,
    saving: boolean,
    bancoPagamento: BancoPagamento | undefined,
    hookForm: UseFormReturn<BancoPagamentoForm>,
    onSubmit: (form: BancoPagamentoForm) => void,
    handleOpenChangeHistory: (idTabela: number | null, tipoTabela: LogTipoTabela | null) => void
    onClose: () => void,

};

export const CadastroBancoPagamentoModal = ({
    open,
    saving,
    hookForm,
    bancoPagamento,
    handleOpenChangeHistory,
    onSubmit,
    onClose,

}: Props) => {


    useEffect(() => {

        if (bancoPagamento) {
            hookForm.setValue("controlaSaldo", bancoPagamento.controlaSaldo);
            hookForm.setValue("ativo", bancoPagamento.ativo);
            hookForm.setValue("nomeBanco", bancoPagamento.nomeBanco);
            hookForm.setValue("nrAgencia", bancoPagamento.nrAgencia);
            hookForm.setValue("nrConta", bancoPagamento.nrConta);
        }
    }, [
        bancoPagamento,
        hookForm,
    ]);

    // usePageStartBootstrap(async () => {
    //     if (bancoPagamento) {
    //         hookForm.
    //     }
    // });

    const handleSubmit = useCallback((form: BancoPagamentoForm) => {
        if (!saving)
            onSubmit(form);

    }, [saving, onSubmit]);

    const handleClose = useCallback(() => {
        if (!saving)
            onClose();

    }, [saving, onClose]);

    return (

        <Dialog
            open={open}
            slotProps={{
                paper: {
                    component: 'form',
                    onSubmit: hookForm.handleSubmit(handleSubmit),
                }
            }}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "45rem",
                    },
                },
            }}>

            <DialogTitle>
                Banco Cadastro
            </DialogTitle>

            <DialogContent>
                <ModalLoading loading={saving}>
                    <FormContainer title={"Informações"} arrangement="fullRow">
                        <>
                            <div className="w-full bg-white p-4 rounded-2xl shadow-sm">
                                <div className="grid grid-cols-1 gap-4">
                                    <div className="flex items-center justify-between">
                                        <label className="font-medium text-gray-700">Status:</label>
                                        <FormSwitchInput
                                            name="ativo"
                                            readOnly={saving}
                                            reactHookForm={hookForm}
                                        />
                                    </div>

                                    <div className="flex items-center justify-between">
                                        <label className="font-medium text-gray-700">Controla Saldo:</label>
                                        <FormSwitchInput
                                            activeLabel="Sim"
                                            inactiveLabel="Não"
                                            name="controlaSaldo"
                                            readOnly={saving}
                                            reactHookForm={hookForm}
                                        />
                                    </div>
                                </div>
                            </div>

                            <DefaultFormInput
                                name='nomeBanco'
                                label='Nome do Banco'
                                readOnly={saving}
                                multiline={false}
                                reactHookForm={hookForm}
                            />

                            <DefaultFormInput
                                name='nrAgencia'
                                label='Nº  da Agência '
                                readOnly={saving}
                                reactHookForm={hookForm}
                            />

                            <DefaultFormInput
                                name='nrConta'
                                label='Nº da Conta '
                                readOnly={saving}
                                reactHookForm={hookForm}
                            />

                        </>
                    </FormContainer>
                </ModalLoading>
            </DialogContent>

            <DialogActions>
                <div className="w-full h-full items-center justify-between flex px-4 pb-4 gap-4">

                    <div>
                        {
                            bancoPagamento &&
                            <>
                                <div>
                                    <PrimaryButton
                                        buttonColor="yellow"
                                        onClick={() => handleOpenChangeHistory(bancoPagamento?.idBancoPagamento ?? null, LogTipoTabela.BANCO_PAGAMENTO)}>
                                        <span className="text-xs">
                                            Historico de alterações
                                        </span>
                                    </PrimaryButton>
                                </div>
                            </>
                        }
                    </div>

                    <div className="flex flex-row gap-2">
                        <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                            <h1
                                className="text-sm text-black dark:text-white"
                                onClick={handleClose}>
                                Cancelar
                            </h1>
                        </div>

                        <div className="w-[120px]">
                            {saving ? (
                                <PrimaryButton
                                    buttonColor="primary-green">
                                    Salvando...
                                </PrimaryButton>
                            ) : (
                                <PrimaryButton
                                    type="submit"
                                    buttonColor="primary-green">
                                    Salvar
                                </PrimaryButton>
                            )}
                        </div>
                    </div>
                </div>
            </DialogActions>
        </Dialog >
    );
}